import React, { useContext, useState, useEffect } from 'react';
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import { Navigate } from "react-router-dom";

const Salir = () => {
  const [authInformation, setAuthInformation] = useContext(InputContext)

  useEffect(() => {
    localStorage.removeItem('token');
    setAuthInformation({token: undefined, rol: undefined, autenticado: false})
  }, []);

  return (
    <div>
      {authInformation.autenticado === false && <Navigate to="/ingreso" />}
      {(authInformation.autenticado === false) && (
        <main className="w-100 m-auto" style={{maxWidth: '330px'}}>
          <h1 className="h3 mb-3 fw-normal">Gracias por utilizar este servicio</h1>
        </main>
      )}
    </div>
  );
};

export default Salir;